import * as React from 'react';
import styles from './textbox.module.scss';

export interface TextboxProps {
    label: string;
    value: string;
}

export class Textbox extends React.Component<TextboxProps> {
    public render() {
        return (
            <div className={styles.textbox}>
                <div className={styles.label}>{this.props.label}</div>
                <div className={styles.inputWrapper}>
                    <input type="text" disabled={true} readOnly={true} value={this.props.value ? this.props.value : ''} />
                </div>
            </div>
        );
    }
}
